import { render, staticRenderFns } from "./app-store-links.vue?vue&type=template&id=220a4240&scoped=true&"
import script from "./app-store-links.vue?vue&type=script&lang=js&"
export * from "./app-store-links.vue?vue&type=script&lang=js&"
import style0 from "./app-store-links.vue?vue&type=style&index=0&id=220a4240&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a4240",
  null
  
)

export default component.exports